<script setup lang="ts">
const { t: $t } = useI18n()

import type { ApiMachineryGetById, ApiTrackerSensorGetByMachineryId, ApiTrackerSensorGetConfigurationOptions } from '~/types'

const props = defineProps<{
  payload: {
    sensor: ApiTrackerSensorGetByMachineryId
    machineryType: ApiMachineryGetById['type']
    configOptions: ApiTrackerSensorGetConfigurationOptions[]
  }
}>()

const emit = defineEmits<{ (e: 'save', data: { sensorId: string, configurationId: string }): void }>()

const columns: OneDataColumn<ApiTrackerSensorGetByMachineryId>[] = [
  {
    title: $t('machinery.details.trackerSensor.assignedSensor'),
    key: 'id',
  },
]

const configTitle = computed(() => {
  const config = props.payload.machineryType.trackerSensorConfiguration
  return config ? `${config.id} - ${config.title}` : null
})

function save(sensor: ApiTrackerSensorGetByMachineryId) {
  if (!sensor.configurationId) {
    return
  }

  emit('save', {
    sensorId: sensor.id,
    configurationId: sensor.configurationId,
  })
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <p v-if="configTitle">
      {{ $t('machinery.details.trackerSensor.sensorConfiguration.popup.fromMachineryType.label', { config: configTitle, machineryType: payload.machineryType.name }) }}
    </p>

    <TableOneDataColumn :config="{ columns, data: payload.sensor }" />

    <FormKit
      type="form"
      :value="payload.sensor"
      :submit-label="$t('button.save')"
      @submit="(data: ApiTrackerSensorGetByMachineryId) => save(data)"
    >
      <FormKit
        type="select"
        name="configurationId"
        validation="required"
        :label="$t('machinery.field.trackerSensorConfiguration.name')"
        :options="payload.configOptions"
        :placeholder="$t('machinery.field.trackerSensorConfiguration.placeholder')"
      />
    </FormKit>
  </div>
</template>
